module.exports = __webpack_public_path__ + "img/quest3.46d22456.png";